<template>
  <div>
    <div class="content-title">・Preparetion Deadline Group {{ listNumber + 1 }}</div>
    <b-container fluid="lg" class="content">
      <b-row>
        <b-col cols="5">
          <div class="mb-2">
            <span class="before-title">before</span>
          </div>
          <div class="date-text">{{ beforeDeadline | ymdhm }}</div>
        </b-col>
        <b-col
          cols="2"
          class="d-flex align-items-center justify-content-center"
          >→</b-col
        >
        <b-col cols="5">
          <div class="mb-2">
            <span class="after-title">after</span>
          </div>
          <ValidationProvider
              :name="`Datetime_${listNumber}`"
              rules="required"
              v-slot="{ errors }"
          >
            <DatetimeInput v-model="afterDeadlineInput" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </b-col>
      </b-row>
    </b-container>
    <div class="booth-list">
      <b-table
        striped
        hover
        fixed
        Outlined
        show-empty
        :empty-text="'No data available'"
        :items="deadlines"
        :fields="fields"
        :table-class="'list-table text-center'"
        :thead-class="'list-table__head'"
        :tbody-class="'list-table__body'"
      />
    </div>

    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="fetch" class="mb-2"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import DatetimeInput from '@/components/parts/inputItem/DatetimeInput.vue';
import { Moment } from 'moment';
import { DeadlineExpiredUpdateParams, DeadlineConditions } from '@/store/deadlines/types'
import PagerComponent from '@/components/parts/Pager.vue';
import { extend, ValidationProvider } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import { Level } from '@/store/master/types'

// バリデーションルール
extend('required', rules.required);
extend('required', { message: 'required.' });

export default Vue.extend({
  data(): {
    afterDeadlineInput: Moment | null;
    fields: Array<object>;
    } {
    return {
      afterDeadlineInput: null,
      fields: [
        {
          key: 'lesson.datetime',
          label: 'Lesson Date',
          formatter: (datetime: Moment): string => datetime.format('YYYY-MM-DD'),
        },
        {
          key: 'tutor.tutorId',
          label: 'Tutor ID',
        },
        {
          key: 'tutor.name',
          label: 'Tutor',
        },
        {
          key: 'lesson.period',
          label: 'Period',
        },
        {
          key: 'lesson.level',
          label: 'Level',
          formatter: (level: Level) => level?.code,
        },
        {
          key: 'lesson.section.name',
          label: 'Section name',
        },
        {
          key: 'expired',
          label: 'Preparation limit',
          formatter: (date: Moment): string => date.format('YYYY-MM-DD HH:mm'),
        },
      ],
    };
  },

  components: {
    DatetimeInput,
    ValidationProvider,
    PagerComponent,
  },

  computed: {
    ...mapState({
      /* eslint-disable */
      //@ts-ignore
      deadlines(state: any) {
        //@ts-ignore
        return state.deadlines.each[this.listNumber]?.deadlines
      },
      //@ts-ignore
      pager(state: any) {
        //@ts-ignore
        return state.deadlines.each[this.listNumber]?.pager
      },
      //@ts-ignore
      beforeDeadline(state: any) {
        //@ts-ignore
        return this.deadlines ? this.deadlines[0].expired : null
        /* eslint-disable */
      },
    }),
  },

  filters: {
    ymdhm: (datetime: Moment | null): string => {
      return datetime
        ? datetime.format('YYYY-MM-DD HH:mm')
        : '----------------';
    },
  },

  props: {
    deadlineIds: Array,
    listNumber: Number,
  },

  async created() {
    await this.fetch();
  },

  methods: {
    async fetch(page = 1) {
      const conditions: DeadlineConditions = {
        ids: this.deadlineIds as string[],
        types: ['preparation'],
      };
      await this.$store.dispatch('fetchDeadlines', {
        conditions,
        page,
        index: this.listNumber,
      });
    },
    async register() {
      await this.$store.dispatch('updateDeadlinesExpired', {
        ids: this.deadlineIds,
        expired: this.afterDeadlineInput,
        comment: this.deadlines[0].comment,
      } as DeadlineExpiredUpdateParams);
    },
  },
});
</script>

<style>
.DeadlineModification__datepickerInput {
  border: none;
  font-size: 15px;
  display: block;
  padding: 5px 20px;
  background: none;
  cursor: pointer;
  width: 100%;
}

.booth-list .list-table .list-table__head {
  font-size: 0.6rem;
}

.booth-list .list-table .list-table__body td {
  font-size: 0.6rem;
  overflow-wrap: break-word;
}

.booth-list .btn {
  min-width: 60px;
  padding: 10px 0;
  font-size: 1rem;
  line-height: 0.5;
}
</style>

<style scoped>
.content-title {
  background: #D8D8D8;
  padding: 5px 10px;
  color: #000;
}

.content {
  background: #fff;
  padding: 15px;
}

.item-text {
  margin-bottom: 10px;
}

.center-border {
  margin: auto;
  width: 10px;
  height: 40%;
  background: #000;
}

.lesson-date {
  background: #ddeaf6;
  border-radius: 30px;
  border: #aaafb6 1px solid;
}

.left-box {
  border-right: 5px solid #b3c6e7;
}

.right-box {
  border-left: 5px solid #b3c6e7;
}

.textarea {
  background: #ddeaf6;
  border: #aaafb6 1px solid;
}

.before-title {
  color: #fff;
  background: #2e75b5;
  padding: 5px 20px;
  border-radius: 30px;
}

.after-title {
  color: #fff;
  background: #d84c60;
  padding: 5px 20px;
  border-radius: 30px;
}

.date-text {
  margin-left: 10px;
  font-size: 16px;
}
</style>
